import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-screen-loader',
  imports: [CommonModule],
  templateUrl: './screen-loader.component.html',
  styleUrl: './screen-loader.component.css'
})
export class ScreenLoaderComponent {
  @Input() visible = false;
  @Input() message = 'Processing';
}
